<template>
    <div>
        <div>
            <b-form-group
                :label="$t('forms.downtimetype')"
                label-for="downtimeType">
                <b-form-select id="downtimeType" v-model="downtimeTypeSelected"
                               :options="downtimetypeOptions"></b-form-select>
            </b-form-group>
            <b-form-group
                :label="$t('comment')"
                label-for="downtimeComment">
                <b-form-input id="downtimeComment" :class="{ 'is-invalid': v$.downtimeComment.$error }"
                              v-model.trim="v$.downtimeComment.$model" placeholder="Commment"></b-form-input>
                <div class="invalid-feedback" v-if="v$.downtimeComment.required">{{ $t('Field is required') }}</div>
            </b-form-group>
            <b-form-group>
                <label for="downtimeStart">Start</label>
                <b-form-input :class="{ 'is-invalid': v$.downtimeStartTime.$error }"
                              v-model.trim="v$.downtimeStartTime.$model" type="datetime-local"></b-form-input>
                <div class="invalid-feedback" v-if="v$.downtimeStartTime.required">{{ $t('Field is required') }}</div>
            </b-form-group>
            <b-form-group>
                <label for="downtimeStart">{{ $t('end') }}</label>
                <b-form-input :class="{ 'is-invalid': v$.downtimeEndTime.$error }"
                              v-model.trim="v$.downtimeEndTime.$model" type="datetime-local"></b-form-input>
                <div class="invalid-feedback" v-if="v$.downtimeEndTime.required">{{ $t('Field is required') }}</div>
            </b-form-group>

            <b-button variant="success" class="w-100" v-on:click="sendDowntimeCommand">{{ $t('forms.send-command') }}</b-button>
        </div>
    </div>
</template>

<script>

/*
SCHEDULE_HOST_DOWNTIME
SCHEDULE_HOST_SVC_DOWNTIME
SCHEDULE_AND_PROPAGATE_HOST_DOWNTIME
SCHEDULE_AND_PROPAGATE_TRIGGERED_HOST_DOWNTIME


 */

import { email, required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { useToast } from "vue-toastification";

export default {
    name: "HostDowntime",
    data(){
        return {
            downtimeTypeSelected: 0,
            downtimetypeOptions: [
                {
                    value:  0,//'SCHEDULE_HOST_DOWNTIME',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 1, //'SCHEDULE_HOST_SVC_DOWNTIME',
                    text: this.$t('hosts.including-services')
                },
                {
                    value: 2, //'SCHEDULE_AND_PROPAGATE_TRIGGERED_HOST_DOWNTIME',
                    text: this.$t('hosts.dependent-triggered')
                },
                {
                    value:  3,//'SCHEDULE_AND_PROPAGATE_HOST_DOWNTIME',
                    text: this.$t('hosts.dependent-not-triggered')
                },

            ],
            downtimeComment: 'in progress',
            downtimeStartTime: '',
            downtimeEndTime: '',
            removeServiceDowntimes: true
        }
    },

    setup: () => ({ v$: useVuelidate() }),
    props: [
        'hostids',
    ],
    validations: {
        downtimeTypeSelected: {
            required
        },
        downtimeComment: {
            required,
        },
        downtimeStartTime: {
            required
        },
        downtimeEndTime: {
            required
        }
    },
    methods: {
        sendDowntimeCommand: async function(){
            if(this.hostids.length === 0){
                useToast().error('no hosts selected', {
                    timeout: 2000
                });
                return
            }
            this.v$.$touch();
            const isFormCorrect = await this.v$.$validate();
            if(!isFormCorrect){
                return;
            }
            let externalCommand = []
            for(let host in this.hostids){
                externalCommand.push({

                    command: 'submitHostDowntime',
                    hostUuid: this.hostids[host].hostUuid,
                    start: this.downtimeStartTime,
                    end: this.downtimeEndTime,
                    author: this.$store.state.user,
                    comment: this.downtimeComment,
                    downtimetype: this.downtimeTypeSelected

                })
            }

            //externalCommand = JSON.stringify(Object.assign({}, externalCommand));
            this.sendCommand(externalCommand);
        },
        sendCommand: function(externalCommand){
            axios.post('/hosts/external_commands.json', externalCommand)
                .then(response => {
                        if(response.data.response.code && response.data.response.code === 403) {
                            useToast().error('insufficient rights', {
                                timeout: 2000
                            });
                        } else {
                            useToast().success(this.$t('Command successfully sent'), {
                                timeout: 7000
                            });
                        }
                        this.$emit('refresh')

                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
        getDates(){
            axios.post('/downtimes/get_dates.json')
                .then(response => {
                        let datetime = response.data.datetime[0];
                        this.downtimeStartTime = datetime.start_time;
                        this.downtimeEndTime = datetime.end_time;
                })
                .catch(error => {
                    console.log('error: ' + error)
                });
        },
    },
    mounted(){
        this.getDates();
    },
}
</script>

<style scoped>

</style>
